export const avatarInputAccept = 'image/png, image/jpeg';
